import { Participant } from '../models';
import { ParticipantRepository, TournamentRepository } from '../repositories';
import { ModerateContentUseCase } from './ModerateContentUseCase';
import { ABSOLUTE_MAX_PARTICIPANTS } from '../models/PlanLimits';

export class AddParticipantUseCase {
  constructor(
    private participantRepository: ParticipantRepository,
    private moderateContent: ModerateContentUseCase,
    private tournamentRepository: TournamentRepository,
  ) {}

  async execute(params: {
    tournamentId: string;
    name: string;
    seed?: number;
    userId?: string;
  }): Promise<Participant> {
    if (!params.name.trim()) {
      throw new Error('Participant name cannot be empty');
    }

    // Check participant limits
    const tournament = await this.tournamentRepository.getById(params.tournamentId);
    if (tournament) {
      const existing = await this.participantRepository.getByTournamentId(params.tournamentId);
      if (tournament.maxParticipants && existing.length >= tournament.maxParticipants) {
        throw new Error('Tournament is full');
      }
      if (existing.length >= ABSOLUTE_MAX_PARTICIPANTS) {
        throw new Error('Tournament has reached the maximum allowed participants');
      }
    }

    // Moderate content before writing
    if (params.userId) {
      await this.moderateContent.execute(params.name, 'participant_name', params.userId);
    }

    const participant = await this.participantRepository.create({
      tournamentId: params.tournamentId,
      name: params.name.trim(),
      seed: params.seed ?? 1,
    });

    return participant;
  }
}
